module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Serge Van de Voorde","short_name":"Serge Van de Voorde","description":"Privéconsultatie fysische geneeskunde en revalidatie in Deinze","start_url":"/","background_color":"#F0EFF2","theme_color":"#4C5866","display":"browser","icon":"src/assets/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"d02f1967b475fa9e5a8b22bc2d5d23e0"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
